// @ts-strict-ignore
import { ActionType } from '../../../store/engine/constants';
import type { Expression } from '../../../store/engine/types';
import type { WorkflowState } from '../../../store/redux/state';
import { getActionName, isActionOfType } from '../actions';


export function convertExpressionToString(args: {
  expression: Expression;
  actions: WorkflowState['workflowData']['actions'];
  dataRoutes: WorkflowState['workflowData']['dataRoutes'];
}): string {
  const {
    actions,
    dataRoutes,
  } = args;

  function recursivelyAddExpressionAsStringToResultArray(localArgs: {
    result: string[];
    expression: Expression;
  }) {
    const { expression, result } = localArgs;
    expression.forEach(operand => {
      const isOperator = typeof operand === 'string' && ['+', '-', '*', '/'].includes(operand);
      const isScalar = (typeof operand === 'number' || typeof operand === 'string') && !isOperator;
      const isDataRoute = typeof operand === 'object' && Object.hasOwn(operand, 'data_route_id');
      const isSubExpression = Array.isArray(operand);

      if (isScalar || isOperator) {
        result.push(String(operand));
      }

      if (isDataRoute) {
        const dataRouteOperand = (operand as { data_route_id: number | string });
        const dataRoute = dataRoutes[dataRouteOperand.data_route_id];
        const sourceAction = actions[dataRoute.sourceId];

        const actionName = getActionName(sourceAction);

        let serviceAttrPostfix: string = '';
        if (isActionOfType(sourceAction, ActionType.SERVICE)) {
          serviceAttrPostfix = `: ${dataRoute.attribute.displayName}`;
        }

        const dataRouteAsString = `${actionName}${serviceAttrPostfix}`;
        result.push(dataRouteAsString);
      }

      if (isSubExpression) {
        const openSubExpressionGroupChar = '(';
        result.push(openSubExpressionGroupChar);

        recursivelyAddExpressionAsStringToResultArray({ result, expression: operand });

        const closeSubExpressionGroupChar = ')';
        result.push(closeSubExpressionGroupChar);
      }
    });
  }


  const result = [];
  recursivelyAddExpressionAsStringToResultArray({ result, expression: args.expression });
  return result.join(' ');
}
